
import Vue from "vue";
import TapestryScoresByCivilization from "@/components/TapestryScoresByCivilization.vue";
import TapestryScoresByDate from "@/components/TapestryScoresByDate.vue";
import TapestryScoresByScenario from "@/components/TapestryScoresByScenario.vue";
import { mapState } from "vuex";

export default Vue.extend({
  name: "ScoresTapestry",
  data: () => ({
    tab: null,
  }),
  components: {
    TapestryScoresByCivilization,
    TapestryScoresByDate,
    TapestryScoresByScenario,
  },
  computed: {
    ...mapState([
      "tapestryPlays",
      "tapestryCivilizations",
      "tapestryCampaigns",
      "tapestryScenarios",
    ]),
  },
  async beforeMount() {
    if (!this.tapestryPlays.length) {
      this.$store.dispatch("getTapestryPlays");
    }
  },
});
